module.exports = __webpack_public_path__ + "static/media/pattern-edit-icon.be8658c4.svg";